/* Cart ticket bundle. Behaviour only, markup is in
   snippets/cart-ticket-bundle.liquid. */
(function () {
  'use strict';

  // ajax-cart.liquid renders twice (mobile + desktop), so this loads twice.
  if (window.__ctbLoaded) return;
  window.__ctbLoaded = true;

  var OPEN_CLASS = 'ctb-packs-open';
  var BUSY_CLASS = 'ctb-busy';
  var BUSY_TIMEOUT = 8000;
  var busy = false;
  var busyTimer = null;
  var settleTimer = null;

  // On #theme-ajax-cart because updateView() replaces everything inside it.
  function setBusy(state) {
    busy = state;
    Array.prototype.forEach.call(document.querySelectorAll('#theme-ajax-cart'), function (d) {
      d.classList.toggle(BUSY_CLASS, state);
    });
    if (!state) {
      window.clearTimeout(busyTimer);
      window.clearInterval(settleTimer);
    }
  }

  // Stale marker stops the clicked block's own highlight from satisfying this.
  function waitForSettle(target) {
    window.clearInterval(settleTimer);
    settleTimer = window.setInterval(function () {
      var fresh = document.querySelector('.ctb--packs:not([data-ctb-stale]) .ctb__opt[aria-pressed="true"]');
      if (fresh && fresh.getAttribute('data-ctb-pack') === String(target)) setBusy(false);
    }, 100);

    window.clearTimeout(busyTimer);
    busyTimer = window.setTimeout(function () {
      setBusy(false);
    }, BUSY_TIMEOUT);
  }

  /* Uses line, not the line item key. Shopocado rewrites its line property on
     every discount pass so a rendered key is usually stale by click time. */
  function setQuantity(target) {
    if (busy) return;

    Array.prototype.forEach.call(document.querySelectorAll('.ctb--packs'), function (block) {
      block.setAttribute('data-ctb-stale', '');
      Array.prototype.forEach.call(block.querySelectorAll('.ctb__opt'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-ctb-pack') === String(target) ? 'true' : 'false');
      });
    });
    setBusy(true);
    waitForSettle(target);

    window
      .fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: 1, quantity: target })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed');
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      })
      .catch(function () {
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        setBusy(false);
      });
  }

  function onClick(e) {
    var el = e.target.closest ? e.target.closest('[data-ctb-pack], [data-ctb-toggle]') : null;
    if (!el) return;

    if (el.hasAttribute('data-ctb-toggle')) {
      e.preventDefault();
      var open = !document.querySelector('.' + OPEN_CLASS);
      Array.prototype.forEach.call(document.querySelectorAll('#theme-ajax-cart'), function (d) {
        d.classList.toggle(OPEN_CLASS, open);
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-ctb-toggle]'), function (t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      return;
    }

    e.preventDefault();
    var target = parseInt(el.getAttribute('data-ctb-pack'), 10);
    if (!target || el.getAttribute('aria-pressed') === 'true') return;

    setQuantity(target);
  }

  document.addEventListener('click', onClick, true);
})();
